import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'hubless',
  historyBasename: '/',
  htmlTitle: 'Accounts Dashboard | HubSpot',
  htmlTitleLangKey: 'main.pageTitle',
  // Whisper core will try to make hub-user-info calls which will fail, as this app is hubless.
  loadWhisperCore: false,
  experimental_newLogoutOnErrorBehavior: true,
  createRootApi: 'tests-only'
});